import { useCallback, useEffect, useState } from "react";
import api from "lib/api";
import SearchSelectContainer from "components/FormDesigner/elements/SearchSelect/SearchSelectContainer";
import { useTranslation } from "react-i18next";
import { CommonPropertyProps } from "schemas/elements";
import { status } from "../../../../constants";
import axios from "axios";
import { AlertProps, SearchSelectOptionProps } from "@alm/flow-ds/components";

type Props = Omit<CommonPropertyProps, "value"> & {
	value: SearchSelectOptionProps[];
	loading: boolean;
	optionsPath?: SearchSelectOptionProps;
	optionsId?: SearchSelectOptionProps;
	addAlert: (alert: string, status: AlertProps["status"]) => void;
};

export default ({
	isEmu,
	updateStore,
	field,
	required,
	value,
	desc,
	validation,
	elementIndex,
	id,
	optionsPath,
	optionsId,
	addAlert,
}: Props) => {
	const { t } = useTranslation();

	const [select, setSelect] = useState<SearchSelectOptionProps[]>([]);
	const [loading, setLoading] = useState<boolean>(false);
	const entity = optionsId?.value.substr(
		optionsId?.value.lastIndexOf("/") + 1
	);

	const getEntitiesList = useCallback(async () => {
		// Gets list of entities with the field path passed
		try {
			setLoading(true);
			const res = await api.entity.getSelectData(
				entity as string,
				optionsPath?.label as string,
				isEmu
			);
			setSelect(res);
		} catch (error) {
			addAlert("errorLoadingFormList", status.ERROR);
			if (error && axios.isAxiosError(error))
				console.error(`Error: ${error.message}`);
		}
		setLoading(false);
	}, [entity, optionsPath?.label, isEmu, addAlert]);

	useEffect(() => {
		if (
			entity !== undefined &&
			entity !== null &&
			optionsPath !== undefined &&
			optionsPath !== null
		) {
			getEntitiesList();
		} else {
			setSelect([]);
			updateStore({
				elementIndex,
				property: field,
				value: null,
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [getEntitiesList, entity, optionsPath]);

	const props = {
		updateStore,
		field,
		required,
		value,
		validation,
		desc,
		elementIndex,
		loading,
		options: select,
		disabled: select.length && optionsPath && optionsId ? false : true,
		disabledPlaceholder: t("formDesigner.placeholders.optionsPathRelation"),
		multiSelect: true,
	};

	return <SearchSelectContainer {...props} />;
};
